import apiSO from '@/api/so';
import apiOption from '@/api/option';
import apiCustomer from '@/api/customer'

const defaultState = () => ({
	listSO: [],
	detailSO: '',
	listProduct: [],
	soAnnually: [],
	soPagination: '',
	warehouseResults: [],
	ProvinceOption: [],
	CityOption: [],
	SubdistrictOption: [],
	OptionPaymentMethod: [],
	OptionStatus: [],
	OptionSoToApprove: [],
	OptionSoToPay: [],
	ListDeliveryPrice: [],
	deliveryPricePagination: '',
	customerDetail: {},
	response: {
		code: '',
		message: ''
	},
	alertMultiple: [],
	responseError: {},
	alert: '',
});

const state = defaultState();

const getters = {
	productSO(state){
		if (state.detailSO) {
			return state.detailSO.so_detail.map((el) => {
        // let serial_type = JSON.stringify(el.so_detail_product_is_serial)
				// serial_type = serial_type ? serial_type : [];

				return {
					product_id: el.so_detail_product_id,
					product_name: el.so_detail_product_name,
					quantity: el.so_detail_quantity_remaining,
					is_serial: JSON.stringify(el.so_detail_product_is_serial),
					serial: el.serial,
					card_type: el.card_type,
					product_batch: el.product_batch_code,
				}
			})
		} else {
			return []
		}
	},
	listProductNotSelected (state) {
		return state.listProduct.filter( (el) => {
			return el.selected == false
		})
	},
	listProductSelected (state) {
		return state.listProduct.filter( (el) => {
			return el.selected == true
		})
	},
};

const mutations = {
	setSO(state, data) {
		state.listSO = data.data
		state.soPagination = data.pagination;
	},
	setSOAnnually(state, data) {
		state.soAnnually = data
	},
	listOptionStatus(state, data) {
		state.OptionStatus = [];
		state.OptionStatus = data;
	},
	setDetailSO(state, data) {
    if (typeof data == 'object') {
      data.so_detail = data.so_detail.map(el => {
        el.is_include = JSON.parse(el.is_include)
        el.so_detail_product_is_serial = JSON.parse(el.so_detail_product_is_serial? el.so_detail_product_is_serial : null)
        if (typeof el.so_detail_product_is_serial == 'object' && el.so_detail_product_is_serial) {
          el.so_detail_product_is_serial = el.so_detail_product_is_serial.map(el2 => {
            el2.serial = ''
            el2.serial_array = []
            return el2
          })
        }
        return el
      })
    }

		if (data.customer_trx_method == 'manual') {
			let detailProduct = data.so_detail.map(el => {
				el.card_type = 'fisik'
				return el
			})
			data.so_detail = detailProduct
			state.detailSO = data
		} else {
			state.detailSO = data
		}
	},
	setProduct(state, data) {
		state.listProduct = data.map( (el) => {
			el.selected = false
			el.quantity = '1'
			return el
		});
	},
	setOptionSoToApprove (state, data) {
		state.OptionSoToApprove = data
	},
	setOptionSoToPay (state, data) {
		state.OptionSoToPay = data
	},
	setPaymentMethod(state, data) {
		state.OptionPaymentMethod = data
	},
	setDetailCustomer(state, data) {
		state.customerDetail = data
	},
	setWarehouse(state, data) {
		state.warehouseResults = data
	},
	setProvince(state, data) {
		let all = {
			province: 'Semua Provinsi',
			province_id: ''
		}
		state.ProvinceOption = [all, ...data]
	},
	setCity(state, data) {
		let all = {
			city_name: 'Semua Kab/Kota',
			city_id: '',
			type: 'Kota'
		}
		state.CityOption = [all, ...data]
	},
	setSubdistrict(state, data) {
		let all = {
			subdistrict_name: 'Semua Kecamatan',
			subdistrict_id: ''
		}
		state.SubdistrictOption = [all, ...data]
	},
	saveResponse(state, data) {
		state.response = data
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		if (data.length == 0) {
			state.alertMultiple = []
		} else {
			state.alertMultiple = data.map((el) => {
				return {
					show: true,
					message: el
				}
			})
		}
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataSO(state) {
		Object.assign(state, defaultState());
	},
	setSOApprovalRefund(state, data) {
		state.listSO = data.data
		state.soPagination = data.pagination;
	},
	setDeliveryPrice(state, data) {
		state.ListDeliveryPrice = data.data
		state.deliveryPricePagination = data.pagination;
	},
};

const actions = {
	getSO({ dispatch, commit }, params) {
		return new Promise((resolve) => {
			apiSO.getSO(params).then(({ data: { data } }) => {
				commit('setSO', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch((err) => {
				commit('setSO', { data: [], pagination: {} });
				const { data } = err.response;
				dispatch('errorHandler', data);
			});
		});
	},
	getSOAnually({ dispatch, commit }, params) {
		return new Promise((resolve) => {
			apiSO.getSOAnually(params).then(({ data: { data } }) => {
				commit('setSOAnnually', data.results);
				resolve()
			}).catch((err) => {
				commit('setSOAnnually', []);
				const { data } = err.response;
				dispatch('errorHandler', data);
			});
		});
	},
	async exportSOAnually({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiSO.exportSOAnually(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Penjualan Bulanan'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	getSOAll({ dispatch, commit }, params) {
		return new Promise((resolve) => {
			apiSO.getSOAll(params).then(({ data: { data } }) => {
				commit('setSO', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch((err) => {
				commit('setSO', { data: [], pagination: {} });
				const { data } = err.response;
				dispatch('errorHandler', data);
			});
		});
	},
	getSORoam({ dispatch, commit }, params) {
		return new Promise((resolve) => {
			apiSO.getSORoam(params).then(({ data: { data } }) => {
				commit('setSO', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch((err) => {
				commit('setSO', { data: [], pagination: {} });
				const { data } = err.response;
				dispatch('errorHandler', data);
			});
		});
	},
	getOptionStatus({ dispatch, commit }) {
		return new Promise((resolve) => {
			apiSO.getOptionStatus().then(({ data: { data: { results } } }) => {
				commit('listOptionStatus', results);
				resolve()
			}).catch((err) => {
				commit('listOptionStatus', []);
				const { data } = err.response;
				dispatch('errorHandler', data);
			});
		});
	},
	getDetailSO({ commit, dispatch }, params) {
		apiSO.getDetailSO(params).then(({ data: { data } }) => {
			data.results.so_detail.map(el => {
				return el.serial = []
			})
			commit('setDetailSO', data.results);
		}).catch((err) => {
			const { data } = err.response
			dispatch("errorHandler", data)
			commit('setDetailSO', { data: [] });
		});
	},
	getOptionProduct({ commit }) {
		apiOption.getOptionProductToSell().then(({ data: { data } }) => {
			commit('setProduct', data.results);
		}).catch(() => {
			commit('setProduct', []);
		});
	},
	getOptionPaymentMethod({ commit }) {
		apiOption.getOptionPaymentMethod().then(({ data: { data } }) => {
			commit('setPaymentMethod', data.results);
		}).catch(() => {
			commit('setPaymentMethod', []);
		});
	},
	getOptionSOforApprove({ dispatch, commit }) {
		apiOption.getOptionSOforApprove().then(({ data: { data: { results } } }) => {
			commit('setOptionSoToApprove', results);
		}).catch((err) => {
			const { data } = err.response;
			dispatch('errorHandler', data);
		});
	},
	getOptionSoforPay({ dispatch, commit }) {
		apiOption.getOptionSoforPay().then(({ data: { data: { results } } }) => {
			commit('setOptionSoToPay', results);
		}).catch((err) => {
			const { data } = err.response;
			dispatch('errorHandler', data);
		});
	},
	async exportSO({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiSO.exportSO(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Sales Order'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportSOAll({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiSO.exportSOAll(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Sales Order'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportSORoam({ commit, dispatch }){
		await dispatch('isAttempting', null, { root: true })
		await apiSO.exportSORoam().then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Sales Order'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async createSO({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiSO.createSO(params).then( res => {
				const data = res.data;
				commit("saveResponse", data);
				commit('setSnackbar', {
					show: true,
					color: 'green accent-4',
					text: data.message
				}, { root: true });
				commit('multipleAlert', [])
				commit('validationError', {})
				resolve()
			}).catch( err => {
				const { data } = err.response
				dispatch("errorHandler", data)
				reject()
			});
		})
	},
	async approvalPayment({ commit, dispatch }, params) {
		await apiSO.approvalPayment(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		}).catch( err => {
			const { data } = err.response
			dispatch("errorHandler", data)
		});
	},
	async approveSO({ commit, dispatch }, params) {
		await apiSO.approveSO(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		}).catch( err => {
			const { data } = err.response
			dispatch("errorHandler", data)
		});
	},
	async cancelSO({ commit, dispatch }, params) {
		await apiSO.cancelSO(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		}).catch( err => {
			const { data } = err.response
			dispatch("errorHandler", data)
		});
	},
	async deleteSO({ commit, dispatch }, params) {
		await apiSO.deleteSO(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		}).catch( err => {
			const { data } = err.response
			dispatch("errorHandler", data)
		});
	},
	async cancelPaymentSO({ commit, dispatch }, params) {
		await apiSO.cancelPaymentSO(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		}).catch( err => {
			const { data } = err.response
			dispatch("errorHandler", data)
		});
	},
	async cancelApprovalSO({ commit, dispatch }, params) {
		await apiSO.cancelApprovalSO(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		}).catch( err => {
			const { data } = err.response
			dispatch("errorHandler", data)
		});
	},
	async detailCustomer({ dispatch, commit }, params) {
		await apiCustomer.getDetailCustomer(params).then(({ data: { data } }) => {
			commit('setDetailCustomer', data.results);
		}).catch((err) => {
			commit('setDetailCustomer', {});
			const { data } = err.response;
			dispatch('errorHandler', data);
		});
	},
	searchCustomer({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiCustomer.searchCustomer(params).then(({ data: { data }  }) => {
				resolve(data.results)
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
				reject()
			});
		})
	},
	getWarehouseOption({ commit }, params){
		return new Promise((resolve) => {
			apiOption.getOptionWarehouseAll(params).then(({ data: { data } }) => {
				commit('setWarehouse', data.results);
				resolve()
			}).catch(() => {
				commit('setWarehouse', []);
			});
		});
	},
	getProvinceOption({ commit }){
		return new Promise((resolve) => {
			commit('setSubdistrict', []);
			commit('setCity', []);
			apiOption.getOptionProvince().then(({ data: { data } }) => {
				commit('setProvince', data.results);
				resolve()
			}).catch(() => {
				commit('setProvince', []);
			});
		});
	},
	getOptionProvince({ dispatch }) {
		return new Promise((resolve) => {
			apiOption.getOptionProvince().then(({ data: { data } }) => {
				resolve(data.results)
			}).catch((err) => {
				const data = err.response.data
				dispatch("errorHandler", data)
			});
		})
	},
	getOptionCityResults({ dispatch }, params) {
		return new Promise((resolve) => {
			apiOption.getOptionCity({province_id: params}).then(({ data: { data } }) => {
				resolve(data.results);
			}).catch((err) => {
				resolve([]);
				const data = err.response.data
				dispatch("errorHandler", data)
			});
		})
	},
	getOptionCity({ commit }, params) {
		return new Promise((resolve) => {
			commit('setSubdistrict', []);
			apiOption.getOptionCity(params).then(({ data: { data } }) => {
				commit('setCity', data.results);
				resolve()
			}).catch(() => {
				commit('setCity', []);
			});
		});
	},
	getOptionSubdistrict({ commit }, params){
		return new Promise((resolve) => {
			apiOption.getOptionSubdistrict(params).then(({ data: { data } }) => {
				commit('setSubdistrict', data.results);
				resolve()
			}).catch(() => {
				commit('setSubdistrict', []);
			});
		});
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error);
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.message
			}, { root: true })
			break;
		}
	},
	getSOApprovalRefund({ dispatch, commit }, params) {
		return new Promise((resolve) => {
			apiSO.getSOApprovalRefund(params).then(({ data: { data } }) => {
				commit('setSOApprovalRefund', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch((err) => {
				commit('setSOApprovalRefund', { data: [], pagination: {} });
				const { data } = err.response;
				dispatch('errorHandler', data);
			});
		});
	},
	async approvalRefundPayment({ commit, dispatch }, params) {
		await apiSO.approvalRefundPayment(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		}).catch( err => {
			const { data } = err.response
			dispatch("errorHandler", data)

			if (data.code == 400) {
				commit('setSnackbar', {
					show: true,
					color: 'red accent-4',
					text: data.message
				}, { root: true });
			}
		});
	},
	async exportSOApprovalRefund({ commit, dispatch }){
		await dispatch('isAttempting', null, { root: true })
		await apiSO.exportSOApprovalRefund().then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Sales Order'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	getSODeliveryPrice({ dispatch }, params) {
		return new Promise((resolve) => {
			apiSO.getSODeliveryPrice(params).then(({ data: { data } }) => {
				resolve(data.results)
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
			});
		});
	},

	getProductShippingPrice({ dispatch }, params) {
		return new Promise((resolve) => {
			apiSO.getProductShippingPrice(params).then(({ data: { data } }) => {
				resolve(data.results)
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
			});
		});
	}
	// getDeliveryPrice({ dispatch, commit }, params) {
	// 	return new Promise((resolve) => {
	// 		apiSO.getDeliveryPrice(params).then(({ data: { data } }) => {
	// 			commit('setDeliveryPrice', { data: data.results, pagination: data.pagination });
	// 			resolve()
	// 		}).catch((err) => {
	// 			commit('setDeliveryPrice', { data: [], pagination: {} });
	// 			const { data } = err.response;
	// 			dispatch('errorHandler', data);
	// 		});
	// 	});
	// },
	// async addDeliveryPrice({ commit, dispatch }, params) {
	// 	return new Promise((resolve, reject) => {
	// 		apiSO.addDeliveryPrice(params).then( res => {
	// 			const data = res.data;
	// 			commit("saveResponse", data);
	// 			commit('setSnackbar', {
	// 				show: true,
	// 				color: 'green accent-4',
	// 				text: data.message
	// 			}, { root: true });
	// 			commit('multipleAlert', [])
	// 			commit('validationError', {})
	// 			resolve()
	// 		}).catch( err => {
	// 			const { data } = err.response
	// 			dispatch("errorHandler", data)
	// 			reject()
	// 		});
	// 	})
	// },
	// async updateDeliveryPrice({ commit, dispatch }, params) {
	// 	return new Promise((resolve, reject) => {
	// 		apiSO.updateDeliveryPrice(params).then( res => {
	// 			const data = res.data;
	// 			commit("saveResponse", data);
	// 			commit('setSnackbar', {
	// 				show: true,
	// 				color: 'green accent-4',
	// 				text: data.message
	// 			}, { root: true });
	// 			commit('multipleAlert', [])
	// 			commit('validationError', {})
	// 			resolve()
	// 		}).catch( err => {
	// 			const { data } = err.response
	// 			dispatch("errorHandler", data)
	// 			reject()
	// 		});
	// 	})
	// },
	// 	async deleteDeliveryPrice({ commit, dispatch }, params) {
	// 	return new Promise((resolve, reject) => {
	// 		apiSO.deleteDeliveryPrice(params).then( res => {
	// 			const data = res.data;
	// 			commit("saveResponse", data);
	// 			commit('setSnackbar', {
	// 				show: true,
	// 				color: 'green accent-4',
	// 				text: data.message
	// 			}, { root: true });
	// 			commit('multipleAlert', [])
	// 			commit('validationError', {})
	// 			resolve()
	// 		}).catch( err => {
	// 			const { data } = err.response
	// 			dispatch("errorHandler", data)
	// 			reject()
	// 		});
	// 	})
	// },
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
